export default (imageSrc) => {
  return new Promise((resolve, reject) => {
    // preload
    const preloadImg = new Image();
    preloadImg.onload = resolve;
    preloadImg.onerror = reject;
    preloadImg.src = imageSrc;
  });
};
